import React, { useEffect } from 'react';
import { Linkedin } from 'lucide-react';

/* ───────────────────────────────────────────────
   TEAM DATA — 14 Core Team + 6 Interns = 20
   Replace name / img / linkedin / status as needed.
   If img is '' or null the slot shows a blank placeholder.
   ─────────────────────────────────────────────── */
const coreTeam = [
  { name: 'Team Member 1',  role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 2',  role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 3',  role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 4',  role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 5',  role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 6',  role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 7',  role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 8',  role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 9',  role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 10', role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 11', role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 12', role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 13', role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
  { name: 'Team Member 14', role: 'Core Team', img: '', linkedin: '#', status: 'Present' },
];

const interns = [
  { name: 'Intern 1', role: 'Intern', img: '', linkedin: '#', status: 'Present' },
  { name: 'Intern 2', role: 'Intern', img: '', linkedin: '#', status: 'Present' },
  { name: 'Intern 3', role: 'Intern', img: '', linkedin: '#', status: 'Present' },
  { name: 'Intern 4', role: 'Intern', img: '', linkedin: '#', status: 'Present' },
  { name: 'Intern 5', role: 'Intern', img: '', linkedin: '#', status: 'Present' },
  { name: 'Intern 6', role: 'Intern', img: '', linkedin: '#', status: 'Present' },
];

/* ── Inline styles — Ekalavya Light Theme (Purple) ── */
const styles = {
  page: {
    background: '#ffffff',
    minHeight: '100vh',
    fontFamily: "'Poppins', sans-serif",
    color: '#111827',
    paddingBottom: '6rem',
    position: 'relative',
  },

  /* ── Hero / Title ── */
  hero: {
    paddingTop: '10rem',
    paddingBottom: '1.5rem',
    textAlign: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    paddingLeft: '2rem',
    paddingRight: '2rem',
  },
  title: {
    fontSize: 'clamp(2rem, 5vw, 3rem)',
    fontWeight: 900,
    background: 'linear-gradient(135deg, #0f172a 0%, #9333ea 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    margin: 0,
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: '1.05rem',
    color: '#4b5563',
    maxWidth: '600px',
    margin: '1rem auto 0',
    lineHeight: 1.7,
  },

  /* ── Section heading ── */
  sectionHeader: {
    textAlign: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '3.5rem 2rem 2rem',
  },
  sectionTitle: {
    fontSize: 'clamp(1.5rem, 3vw, 2rem)',
    fontWeight: 800,
    color: '#0f172a',
    marginBottom: '0.5rem',
  },
  sectionLine: {
    width: '60px',
    height: '4px',
    borderRadius: '2px',
    background: 'linear-gradient(90deg, #9333ea, #c084fc)',
    margin: '0 auto',
  },

  /* ── Grid ── */
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '2.5rem 2rem',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 2rem',
  },

  /* ── Card ── */
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: '1.75rem 1rem',
    borderRadius: '1.25rem',
    background: '#ffffff',
    border: '1px solid rgba(147, 51, 234, 0.1)',
    boxShadow: '0 2px 12px rgba(147, 51, 234, 0.04)',
    transition: 'transform 0.3s cubic-bezier(.25,.46,.45,.94), box-shadow 0.3s ease',
  },
  cardHover: {
    transform: 'translateY(-6px)',
    boxShadow: '0 12px 40px rgba(147, 51, 234, 0.12)',
  },

  /* ── Photo frame — rounded square with purple gradient border ── */
  photoFrame: {
    width: '150px',
    height: '150px',
    borderRadius: '22px',
    padding: '3px',
    background: 'linear-gradient(135deg, #9333ea, #c084fc)',
    marginBottom: '1rem',
    transition: 'transform 0.35s cubic-bezier(.25,.46,.45,.94)',
  },
  photoFrameHover: {
    transform: 'scale(1.05)',
  },
  photoInner: {
    width: '100%',
    height: '100%',
    borderRadius: '19px',
    overflow: 'hidden',
    background: '#faf5ff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  photo: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  placeholderIcon: {
    width: '44px',
    height: '44px',
    opacity: 0.3,
  },

  /* ── Name ── */
  name: {
    fontSize: '1rem',
    fontWeight: 700,
    color: '#0f172a',
    marginBottom: '0.25rem',
    lineHeight: 1.3,
    minHeight: '1.3em',
  },

  /* ── Role label ── */
  roleLabel: {
    fontSize: '0.78rem',
    fontWeight: 500,
    color: '#6b7280',
    marginBottom: '0.75rem',
  },

  /* ── Badge row ── */
  badgeRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.6rem',
  },

  /* ── Status badge ── */
  badge: {
    fontSize: '0.72rem',
    fontWeight: 600,
    padding: '0.3rem 0.85rem',
    borderRadius: '9999px',
    letterSpacing: '0.03em',
  },
  badgePresent: {
    color: '#9333ea',
    border: '1.5px solid #9333ea',
    background: 'rgba(147, 51, 234, 0.06)',
  },
  badgeAlumni: {
    color: '#6b7280',
    border: '1.5px solid #d1d5db',
    background: 'rgba(107, 114, 128, 0.06)',
  },

  /* ── LinkedIn icon ── */
  linkedinLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#9333ea',
    transition: 'color 0.2s, transform 0.2s',
    textDecoration: 'none',
  },

  /* ── Decorative accent ── */
  meshGradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '400px',
    background: 'linear-gradient(160deg, #ffffff 0%, #faf5ff 40%, #f3e8ff 100%)',
    pointerEvents: 'none',
    zIndex: 0,
  },
  content: {
    position: 'relative',
    zIndex: 1,
  },
};

/* ── Responsive CSS injected once ── */
const responsiveCSS = `
  @media (max-width: 1024px) {
    .team-grid { grid-template-columns: repeat(3, 1fr) !important; }
  }
  @media (max-width: 768px) {
    .team-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 1.5rem !important; }
    .team-photo-frame { width: 130px !important; height: 130px !important; }
    .team-card { padding: 1.25rem 0.75rem !important; }
  }
  @media (max-width: 480px) {
    .team-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 1rem !important; padding: 0 1rem !important; }
    .team-photo-frame { width: 110px !important; height: 110px !important; border-radius: 16px !important; }
    .team-hero { padding-left: 1rem !important; padding-right: 1rem !important; padding-top: 7rem !important; }
    .team-card { padding: 1rem 0.5rem !important; }
  }
`;

/* ── Placeholder SVG for empty photos ── */
function PlaceholderSVG() {
  return (
    <svg style={styles.placeholderIcon} viewBox="0 0 24 24" fill="none" stroke="#9333ea" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

/* ── Card component ── */
function TeamCard({ member }) {
  const [hovered, setHovered] = React.useState(false);
  const hasPhoto = member.img && member.img.trim() !== '';
  const isPresent = (member.status || 'Present').toLowerCase() === 'present';

  return (
    <div
      className="team-card"
      style={{
        ...styles.card,
        ...(hovered ? styles.cardHover : {}),
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Photo frame */}
      <div
        className="team-photo-frame"
        style={{
          ...styles.photoFrame,
          ...(hovered ? styles.photoFrameHover : {}),
        }}
      >
        <div style={styles.photoInner}>
          {hasPhoto ? (
            <img src={member.img} alt={member.name} style={styles.photo} loading="lazy" />
          ) : (
            <PlaceholderSVG />
          )}
        </div>
      </div>

      {/* Name */}
      <div style={styles.name}>{member.name}</div>

      {/* Role */}
      {member.role && (
        <div style={styles.roleLabel}>{member.role}</div>
      )}

      {/* Badge + LinkedIn */}
      <div style={styles.badgeRow}>
        <span
          style={{
            ...styles.badge,
            ...(isPresent ? styles.badgePresent : styles.badgeAlumni),
          }}
        >
          {isPresent ? 'Present' : 'Alumni'}
        </span>
        {member.linkedin && member.linkedin !== '' && (
          <a
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            style={styles.linkedinLink}
            onMouseEnter={e => { e.currentTarget.style.color = '#0077b5'; e.currentTarget.style.transform = 'scale(1.15)'; }}
            onMouseLeave={e => { e.currentTarget.style.color = '#9333ea'; e.currentTarget.style.transform = 'scale(1)'; }}
            aria-label={`${member.name} LinkedIn`}
          >
            <Linkedin size={18} />
          </a>
        )}
      </div>
    </div>
  );
}

/* ── Main page ── */
export default function Team() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Inject responsive styles */}
      <style>{responsiveCSS}</style>

      <div style={styles.page}>
        {/* Top gradient background wash */}
        <div style={styles.meshGradient} />

        <div style={styles.content}>
          {/* Hero Title */}
          <div className="team-hero" style={styles.hero}>
            <div className="section-label-pill" style={{ margin: '0 auto 1.5rem' }}>
              <span className="section-label-dot" />
              <span className="section-label-text">Our Team</span>
            </div>
            <h1 style={styles.title}>
              Meet the Minds Behind Ekalavya
            </h1>
            <p style={styles.subtitle}>
              We are a collective of educators, engineers, and community builders dedicated to making learning accessible and rewarding for everyone.
            </p>
          </div>

          {/* ── Core Team Section ── */}
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>Core Team</h2>
            <div style={styles.sectionLine} />
          </div>
          <div className="team-grid" style={styles.grid}>
            {coreTeam.map((member, i) => (
              <TeamCard key={`core-${i}`} member={member} />
            ))}
          </div>

          {/* ── Interns Section ── */}
          <div style={styles.sectionHeader}>
            <h2 style={styles.sectionTitle}>Interns</h2>
            <div style={styles.sectionLine} />
          </div>
          <div className="team-grid" style={styles.grid}>
            {interns.map((member, i) => (
              <TeamCard key={`intern-${i}`} member={member} />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
